import { useRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { StyledError } from 'ggx-componentlibrary/components/text-field/text-field.component.styles'
import {
  Container,
  StyleHelper,
  StyledTextArea,
} from './text-area.component.style'

const TextArea = ({
  className,
  placeholder,
  minRows,
  meta,
  input,
  maxLength,
}) => {
  const inputRef = useRef()
  const inputStyleRef = useRef(0)
  const adjustTextareaRows = useCallback(
    textareaElem => {
      input.onChange(textareaElem.value)
      const mimicker = textareaElem.nextElementSibling
      mimicker.innerHTML =
        (textareaElem.value.replace(/(?<=\r\n?|\n)$/, '<br>') || '<br>') +
        `<span></span>`
      textareaElem.rows = minRows
      textareaElem.rows =
        (textareaElem.scrollHeight -
          inputStyleRef.current.paddingTop -
          inputStyleRef.current.paddingBottom) /
        inputStyleRef.current.lineHeight

      if (mimicker.nextElementSibling) {
        const {
          left,
          right,
          top,
          bottom,
        } = mimicker.nextElementSibling.getBoundingClientRect()
        const { x, y } = mimicker.lastElementChild.getBoundingClientRect()
        const _y = y + inputStyleRef.current.lineHeight / 2
        if (left <= x && x <= right && top <= y && y <= bottom) {
          textareaElem.rows += 1
        }
      }
    },
    [input]
  )
  useEffect(() => {
    inputRef.current.value = input.value
    inputRef.current.rows = minRows
    const style = window.getComputedStyle(inputRef.current)
    inputStyleRef.current = {
      paddingTop: Number(style['padding-top'].replace(/\D/g, '')),
      paddingBottom: Number(style['padding-bottom'].replace(/\D/g, '')),
      lineHeight: Number(style['line-height'].replace(/\D/g, '')),
    }
    if (input.value) {
      adjustTextareaRows(inputRef.current)
    }
  }, [])

  const error = (meta.submitFailed || meta.dirty) && meta.error
  return (
    <div className={className}>
      <Container>
        <StyledTextArea
          ref={inputRef}
          placeholder={placeholder}
          name={input.name}
          error={error}
          onChange={event => adjustTextareaRows(event.target)}
          data-error-field={!!error}
        />
        <StyledTextArea as="div" className="mimicker">
          <span>{placeholder}</span>
        </StyledTextArea>
        {maxLength && (
          <StyleHelper typographyStyles={error ? 'c-red_medium' : ''}>
            {input.value.length}/{maxLength}
          </StyleHelper>
        )}
      </Container>
      {error && error.length > 0 && (
        <StyledError>{error}</StyledError>
      )}
    </div>
  )
}

TextArea.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  minRows: PropTypes.number,
  meta: PropTypes.shape({
    dirty: PropTypes.string,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func,
  }),
  maxLength: PropTypes.number,
}

TextArea.defaultProps = {
  meta: {},
  input: {},
  minRows: 1,
}

export { TextArea }
